export default function getS3Domain() {
    const url = import.meta.env.VITE_WM_API_URL;
    if (!url) {
        return 'https://widget-market.s3lds.ru/'; // prod
    }
    return 'https://83c53623-95b4-496c-a3bb-1d7973abf9d3.selstorage.ru/'; // dev
}